export const FILE_FETCH = "FILE_FETCH";
export const FILE_UPLOAD = "FILE_UPLOAD";
export const FILE_MOVE = "FILE_MOVE";
export const FILE_REMOVE = "FILE_REMOVE";
export const FILE_UPDATE = "FILE_UPDATE";
export const FILE_CHANGE = "FILE_CHANGE";
